import React from 'react';

import { Portal } from '@bringg-frontend/bringg-web-infra';

import SkillsPage from './skills-page/skills-page';

const SkillsPagePortal = () => <Portal element={<SkillsPage />} nodeId={'skills-page'} />;

export { SkillsPagePortal };
